<template>
  <div class="section-avatar-decoration">
    <div class="section-title"></div>
    <div class="section-content">
      <div class="avatar-receive-wrapper">
        <div class="user-info">
          <div class="avatar">
            <img
              v-src="
                gd.user_info.avatar ||
                'https://imgheybox.max-c.com/dev/bbs/2025/01/20/1b007418dd037f165a35918edd1b7bca.png'
              "
              alt=""
            />
            <img
              class="avatar-decoration"
              src="https://imgheybox.max-c.com/oa/2025/01/23/ecd87490b7bfd3ca4621814aa88ea5e7.gif"
            />
          </div>
          <div class="user-name">
            {{ gd.user_info.username }}
          </div>
        </div>
        <div
          class="btn-receive"
          :class="{
            disabled: cd.state === 1,
            active: cd.state !== 1 && following.length >= 5,
          }"
          @click="handleReceive"
        >
          {{
            cd.state === 1 || following.length >= 5
              ? ''
              : `关注 ${following.length}/5`
          }}
        </div>
      </div>
      <div class="wish-container" ref="wishContainer">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            :data-linkid="user.link_id"
            :data-userid="user.heybox_id"
            v-for="user in devUserList"
            :key="user.heybox_id"
          >
            <div class="wish-card">
              <div class="wish-word">
                <img :src="user.wish_img" alt="" />
              </div>
              <div class="wish-user">
                <img class="avatar" v-src="user.avatar" alt="" />
                <p class="user-name">{{ user.username }}</p>
              </div>
              <div class="btn-follow">
                <HbIcon common-add />
                <span>关注</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { difference, union } from 'lodash';
import { executeProtocol, showMessage, redirectUrlByServer } from '_lib/utils';
import { getReceiveAward } from '_api/activity-common-template';

import Swiper, { Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
Swiper.use([Autoplay]);

import { followUser, unFollowUser } from '_api/account/profile';

export default {
  props: {
    act_id: {
      type: String,
      default: '',
    },
    cc: {
      type: Object,
      default: () => ({}),
    },
    cd: {
      type: Object,
      default: () => ({}),
    },
    gd: {
      type: Object,
      default: () => ({}),
    },
    followingIds: {
      type: Array,
      default: () => [],
    },
    devUserList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      following: [],
      activePageIndex: 0,
    };
  },
  mounted() {
    this.following = this.followingIds;
    this.initSwiper();
    this.$nextTick(() => {
      this.$refs.wishContainer
        .querySelectorAll('.swiper-slide')
        .forEach((item, index) => {
          const id = item.getAttribute('data-userid');
          if (this.following.includes(Number(id))) {
            item.setAttribute('data-followed', 'true');
            item.querySelector('.btn-follow').classList.add('followed');
            item.querySelector('.btn-follow').querySelector('span').innerHTML =
              '已关注';
          }
        });
    });
  },
  methods: {
    initSwiper() {
      new Swiper('.wish-container', {
        observer: true,
        slidesPerView: 'auto',
        // centeredSlides: true,
        // slideToClickedSlide: true,
        spaceBetween: 8,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        loop: true,
        on: {
          slideChange: (swiper) => {
            this.activePageIndex = swiper.realIndex;
          },
          // slideChangeTransitionEnd: (swiper) => {
          //   swiper.slideToLoop(swiper.realIndex, 0, true);
          // },
          click: (swiper, e) => {
            const userid = swiper.clickedSlide.getAttribute('data-userid');
            const linkid = swiper.clickedSlide.getAttribute('data-linkid');

            if (
              e.target.classList.contains('btn-follow') ||
              e.target.parentNode.classList.contains('btn-follow')
            ) {
              const isFollowed =
                swiper.clickedSlide.getAttribute('data-followed') == 'true';
              this.handleFollow(userid, isFollowed);
            } else {
              if (linkid) {
                executeProtocol({
                  protocol_type: 'openWindow',
                  webview: {
                    url: redirectUrlByServer(
                      `/v3/bbs/app/api/web/share/?link_id=${linkid}`,
                      'heybox',
                    ),
                  },
                });
              } else {
                showMessage(
                  'failed',
                  '新年的钟声还未敲响，请耐心等待厂商的祝福',
                );
              }
            }
          },
        },
      });
    },
    handleFollow(id, isFollowed) {
      if (this.followLock) {
        return;
      }
      this.followLock = true;
      let request = isFollowed ? unFollowUser : followUser;
      request(
        {
          os_type: 'webinapp',
        },
        {
          following_id: id,
        },
      ).then((res) => {
        if (res.data.status == 'ok') {
          if (isFollowed) {
            this.following = difference(this.following, [Number(id)]);
          } else {
            this.following = union(this.following, [Number(id)]);
          }
          this.$refs.wishContainer
            .querySelectorAll(`[data-userid="${id}"]`)
            .forEach((item) => {
              item.setAttribute('data-followed', isFollowed ? 'false' : 'true');
              item.querySelector('.btn-follow').classList.toggle('followed');
              item
                .querySelector('.btn-follow')
                .querySelector('span').innerHTML = isFollowed
                ? '关注'
                : '已关注';
            });

          isFollowed
            ? showMessage('ok', '已取消关注')
            : showMessage('ok', '关注成功！');
        }
        this.followLock = false;
      });
    },
    handleReceive() {
      if (this.cd.state === 1) {
        executeProtocol({
          protocol_type: 'openRouterPath',
          path: 'setting/avatardecor',
        });
        return;
      }
      if (this.following.length < 5) {
        showMessage('failed', '暂未达到领取条件');
        return;
      }

      getReceiveAward({
        // heybox_id: this.querys.heybox_id,
        act_id: this.act_id,
        cpt_key: this.cc.cpt_key,
      }).then((res) => {
        if (res.data.status === 'ok') {
          showMessage('ok', '领取成功');
          this.$emit('refreshData');
          // this.state = 1;
          // this.$refs['receive-modal'].showModal();
        } else {
          showMessage('failed', res.data.msg);
        }
      });
    },
  },
};
</script>

<style lang="less">
.section-avatar-decoration {
  width: 100%;
  margin-top: 30px;
  padding: 0 12px;
  .section-title {
    width: 100%;
    padding-top: calc(57 / 351 * 100%);
    background: center / auto 100%
      url(https://imgheybox.max-c.com/oa/2025/01/24/b0becd86f4740d30b6ec0217fc72997f.png)
      no-repeat;
  }
  .section-content {
    width: 100%;
    border-radius: 10px;
    background: center top / 100% 80px
      linear-gradient(0deg, #ffffff 0%, #ffffe2 100%) no-repeat #ffffff;
    margin-top: 6px;
    .avatar-receive-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 15px 17px 0 22px;
      .user-info {
        display: flex;
        align-items: center;
        .avatar {
          position: relative;
          width: 49px;
          height: 49px;
          // border-radius: 50%;
          // overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .avatar-decoration {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 68px;
            height: 68px;
            border-radius: 0;
            transform: translate(-50%, -50%);
          }
        }
        .user-name {
          margin-left: 13px;
          color: #d0001b;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
        }
      }
      .btn-receive {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 35px;
        color: #ffeddc;
        font-size: 15px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: -0.06em;
        background: center / 100% 100%
          url(https://imgheybox.max-c.com/oa/2025/01/22/777775b5413b4c82d20ed6553fb32103.png)
          no-repeat;
        &.active {
          background: center / 100% 100%
            url(https://imgheybox.max-c.com/oa/2025/01/20/2495c2363a45a257c52c138d7cf4da4d.png)
            no-repeat;
        }
        &.disabled {
          background-image: url(https://imgheybox.max-c.com/oa/2025/01/23/abcd469c95a62e6ace7f2df2a727ef91.png);
        }
      }
    }
    .wish-container {
      margin: 9px 14px 0;
      padding: 0 0 14px;
      overflow: hidden;
      .swiper-slide,
      .wish-card {
        width: 135px;
        height: 180px;
      }
      .wish-card {
        position: relative;
        background: center / 100% 100%
          url(https://imgheybox.max-c.com/oa/2025/01/20/2d39a2170b04acce03409cb3380aee8a.png)
          no-repeat;
        .wish-word {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .wish-user {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: absolute;
          left: 0;
          top: 62px;
          width: 100%;
          .avatar {
            width: 49px;
            height: 49px;
            border-radius: 50%;
            border: 2px solid #ffc577;
            box-shadow: 0px 2.21px 3.32px 0px #00000026;
            overflow: hidden;
          }
          .user-name {
            width: 100%;
            color: #ffeddc;
            font-size: 14px;
            font-weight: 500;
            line-height: 16px;
            padding: 0 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
            margin-top: 2px;
          }
        }
        .btn-follow {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          left: 50%;
          bottom: 13px;
          width: 80px;
          height: 28px;
          background: linear-gradient(263.62deg, #ffd99e 4.77%, #ffebd0 92.7%);
          border-radius: 16px;
          color: #d0001b;
          font-size: 13px;
          font-weight: 500;
          line-height: 18px;
          transform: translateX(-50%);
          &.followed {
            background: #ff7676;
            color: #d43449;
            > i {
              display: none;
            }
          }
          > i {
            font-size: 12px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>
